
type Params = { profile: any; item: any; location?: any; maxBid?: number }

const pushKlaviyoBidEvent = ({ profile, item, location, maxBid }: Params) => {
  // @ts-ignore
  const klaviyo = window.klaviyo || []
  const auctionNumber = item.auctionNumber || item?.auction?.auctionNumber

  klaviyo.identify({
    email: profile.email,
    first_name: profile.firstName,
    last_name: profile.lastName,
  })
  klaviyo.push([
    'track',
    'Placed Bid',
    {
      itemID: item.id,
      locationID: location?.id || null,
      locationName: location?.nickName || null,
      auctionNumber: auctionNumber,
      bidderID: profile.id,
      oldBidValue: item.currentBid,
      currentBidValue: item.nextBid,
      bidderEmailID: profile.email,
      lotCode: item.lotCode,
      lotTitle: item.title,
      lotMsrp: item.msrp,
      category1: item.category1,
      category2: item.category2,
      platform: 'web',
      ...(typeof maxBid === 'number' && { maxbid: maxBid }),
      // Klaviyo special fields
      $event_id: `bidButton?itemId=${item.id}&lotCode=${item.lotCode}&auctionNumber=${auctionNumber}&bid=$${item.nextBid}&bidderID=${profile.id}&currentBid=${item.currentBid}`,
      $value: Number((item.nextBid - item.currentBid).toFixed(2)),
    },
    function (response: string) {
      // This is a callback function that will run after the event is tracked
    },
  ])
}

export default pushKlaviyoBidEvent
